module.exports = __webpack_public_path__ + "static/media/fantasi.65802bb1.mp3";